import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import NumberHelper from 'util/number_helper';
import * as QueryParams from 'components/Explorer/models/query_params';
import Source from './Source';
import useQueryParams from 'hooks/useQueryParams';

const InspectorSource = ({ source, isFocused }) => {
  const params = useQueryParams();
  const anchorEl = useRef();

  const filters = { ...(params.filters || {}), 'mention_sources[]': [`type:${source.name}`] };
  const to = QueryParams.locationFor(QueryParams.withFilters(params, filters), '/mentions');

  useEffect(() => {
    if (isFocused) anchorEl.current.focus();
  }, [isFocused]);

  return (
    <div className={`source ${source.name}`}>
      <Link to={to} ref={anchorEl}>
        <div className="title">
          <div className="swatch" style={{ backgroundColor: source.color }} />
          {I18n.t(source.name, { scope: 'Explorer.Highlights.Breakdown.sources' })}
        </div>
        <div className="count">
          {I18n.t('Explorer.Highlights.Breakdown.mentions', {
            count: source.mentionCount,
            formattedCount: NumberHelper.formatNumberWithDelimiter(source.mentionCount)
          })}
        </div>
      </Link>
    </div>
  );
};

InspectorSource.propTypes = {
  source: PropTypes.instanceOf(Source).isRequired,
  isFocused: PropTypes.bool
};

export default InspectorSource;
